"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ModalStore = /** @class */ (function () {
    function ModalStore(rootStore) {
        var _this = this;
        this.openModal = function (content) {
            console.log(content);
            _this.modal.open = true;
            _this.modal.body = content;
        };
        this.closeModal = function () {
            _this.modal.open = false;
            _this.modal.body = null;
        };
        this.rootStore = rootStore;
        this.modal = {
            open: false,
            body: null
        };
        mobx_1.makeAutoObservable(this);
    }
    return ModalStore;
}());
exports.default = ModalStore;
//# sourceMappingURL=ModalStore.js.map